import backend, {JOB_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const createJob = (job) => {
  const url = `${JOB_API}/career/job`;
  return backend.post(url, job);
};

const getJob = async (jobRn, loadApplicants = true, loadClient) => {
  const queryParam = {
    loadApplicants: loadApplicants,
    loadClient: loadClient,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${JOB_API}/career/job/${jobRn}?${query}`;
  return backend.get(url);
};

const queryJob = (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey: lastEvaluatedKey,
  };
  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }
  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${JOB_API}/career/job?${query}`;
  return backend.get(url);
};

const updateJobStatus = (jobRn, status) => {
  const url = `${JOB_API}/career/job/${jobRn}`;
  return backend.put(url, status);
};

const updateJob = (jobRn, job) => {
  const url = `${JOB_API}/career/job/${jobRn}/update`;
  return backend.put(url, job);
};

const updateApplicationStatus = (jobRn, caregiverRn, status) => {
  const url = `${JOB_API}/career/job/${jobRn}/application/${caregiverRn}`;
  const body = {
    status: status,
  };
  return backend.put(url, body);
};

const externalApplicationAccept = (jobRn, externalApplicationRn, status) => {
  const url = `${JOB_API}/career/job/${jobRn}/application/external/${externalApplicationRn}/status/accept`;
  const body = {
    status: status,
  };
  return backend.put(url, body);
};

const externalApplicationReject = (jobRn, externalApplicationRn, status) => {
  const url = `${JOB_API}/career/job/${jobRn}/application/external/${externalApplicationRn}/status/reject`;
  const body = {
    status: status,
  };
  return backend.put(url, body);
};

const outsourcedApplicationAccept = (jobRn, caregiverRn) => {
  const url = `${JOB_API}/career/job/${jobRn}/application/outsourced/${caregiverRn}/status/accept`;
  return backend.put(url);
};

const outsourcedApplicationReject = (jobRn, caregiverRn) => {
  const url = `${JOB_API}/career/job/${jobRn}/application/outsourced/${caregiverRn}/status/reject`;
  return backend.put(url);
};

export default {
  createJob,
  getJob,
  queryJob,
  updateJob,

  updateJobStatus,
  updateApplicationStatus,

  externalApplicationAccept,
  externalApplicationReject,

  outsourcedApplicationAccept,
  outsourcedApplicationReject,
};
